// BREACH CATEGORY
export const GET_BREACH_CATEGORIES = '/breach-category/query';
export const GET_BREACH_CATEGORY = '/breach-category/';
export const POST_BREACH_CATEGORY = '/breach-category/';
export const PUT_BREACH_CATEGORY = '/breach-category/';
export const DELETE_BREACH_CATEGORY = '/breach-category/';
export const CHECK_BREACH_CATEGORY_EXISTS = '/breach-category/query';
